import gql from 'graphql-tag'

export const DELETE = gql`
  mutation currency_delete($id: ID!) {
    currencyDelete(id: $id) {
      id
    }
  }
`
